import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getWaterRightPositionList as getWaterRightPositionListApi,
	getWaterRightPositionListQuery as getWaterRightPositionListQueryApi,
	getWaterRightPosition as getWaterRightPositionApi,
	addNewWaterRightPositionApi,
	updateWaterRightPositionApi,
	deleteWaterRightPositionApi,
	checkWaterRightPositionExistsApi,
} from '../../helpers/water_right_position/api_helper';

export const getWaterRightPositionList = createAsyncThunk(
	'waterRightPosition/getWaterRightPositionList',
	async () => {
		try {
			const response = await getWaterRightPositionListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las posiciones.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getWaterRightPositionListQuery = createAsyncThunk(
	'waterRightPosition/getWaterRightPositionListQuery',
	async params => {
		try {
			const response = getWaterRightPositionListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterRightPosition = createAsyncThunk(
	'waterRightPosition/getWaterRightPosition',
	async water_right_position_id => {
		try {
			const response = await getWaterRightPositionApi(water_right_position_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la posición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addNewWaterRightPosition = createAsyncThunk(
	'waterRightPosition/addNewWaterRightPosition',
	async water_right_position => {
		try {
			const response = await addNewWaterRightPositionApi(water_right_position);
			toast.success('Posición agregada exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la posición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateWaterRightPosition = createAsyncThunk(
	'waterRightPosition/updateWaterRightPosition',
	async water_right_position => {
		try {
			const response = await updateWaterRightPositionApi(water_right_position);
			toast.success('Posición actualizada exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la posición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteWaterRightPosition = createAsyncThunk(
	'waterRightPosition/deleteWaterRightPosition',
	async water_right_position => {
		try {
			await deleteWaterRightPositionApi(water_right_position._id);
			toast.success('Posición eliminada exitosamente.', { autoClose: 3000 });
			return water_right_position;
		} catch (error) {
			toast.error('Error al eliminar la posición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const checkWaterRightPositionExists = createAsyncThunk(
	'waterRightPosition/checkWaterRightPositionExists',
	async name => {
		try {
			const response = await checkWaterRightPositionExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
